import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Browse from "./browse";
import { formatPrice } from "../utils/formatPrice";

function Seacrhproducts({ seacrHide, searchvalue, searchlist, closeModal }) {
  const navigate = useNavigate();

  const goToProduct = (e, productId) => {
    e.preventDefault();
    e.stopPropagation();
    // Close first path covering, then route — seacrHideForNav skips old-scroll restore
    if (typeof seacrHide === "function") {
      seacrHide();
    } else if (typeof closeModal === "function") {
      closeModal(false);
    }
    navigate(`/products/productdetails/${productId}`);
    requestAnimationFrame(() => {
      try { window.scrollTo(0, 0); } catch (err) { /* ignore */ }
    });
  };

  return (
    <div className="SearchModalResultsRoot">
      <div className="SearchModalResultsProduct">
        {searchlist && searchlist.length > 0 ? (
          <div className="App HomeSection SearchModalResultsHome">
            <div className="BreakPointContainer SearchModalResultsInner">
              <div className="CarouselSectionContainer CarouselOneSectionContainer">
                <div className="layout row justify-space-between align-center text-left SectionTitle">
                  <h1 className="m-t-0 m-b-0 demi-bold w-auto">
                    Showing result for {searchvalue}
                  </h1>
                </div>
                <div className="SearchModalProductGrid">
                  {searchlist.map((product, index) => (
                    <div className="item SearchModalProductItem" key={`${product.id}-${index}`}>
                      <div className="CarouselSection product">
                        <div className="prel Gutter">
                          <Link
                            to={`/products/productdetails/${product.id}`}
                            onClick={(e) => goToProduct(e, product.id)}
                          >
                            <div
                              className="DynamicHeightLoaderWrapper"
                              style={{
                                paddingTop: "130%",
                                overflow: "hidden",
                                position: "relative",
                              }}
                            >
                              <div
                                className="DynamicHeightLoader layout row align-center justify-center"
                                style={{ paddingTop: "20%" }}
                              >
                                <img
                                  src={product.product_thumbail}
                                  alt={product.product_title}
                                  className="img-resp DynamicHeightLoaderImage"
                                  style={{ padding: "0px" }}
                                  loading="lazy"
                                  decoding="async"
                                />
                              </div>
                            </div>
                            <div className="ImageTextDetail ProductImageTextDetail">
                              <label className="ellipsis h5 ImageTextLabelTop m-t-5 demi-bold">
                                {product.product_title}
                              </label>
                              <label className="h6 ellipsis-two-line font-normal ImageTextLabelBottom block font-normal">
                                {product.product_short_description}
                              </label>
                              <div className="ProductPrice layout row wrap">
                                <span className="SpecialPrice p2 demi-bold w-auto p-0 detail_spc">
                                  ₹
                                  {formatPrice(
                                    product?.saleprice > 0
                                      ? product?.saleprice
                                      : product?.price,
                                    { showSymbol: false }
                                  )}
                                </span>
                                {product?.discount_amount > 0 && (
                                  <span className="InitialPrice p3 w-auto p-0">
                                    ₹{formatPrice(product?.price, { showSymbol: false })}
                                  </span>
                                )}
                                {product?.discount_amount > 0 && (
                                  <span className="DiscountPriceRound p3 w-auto p-0">
                                    {product?.discount_type === "flat"
                                      ? `${product?.discount_amount} FLAT OFF`
                                      : product?.discount_type === "percentage"
                                      ? `${product?.discount_amount}% OFF`
                                      : ""}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="SearchModalEmpty">
              <p>
                No result found for{" "}
                <span className="bold">{searchvalue}</span>
              </p>
            </div>
            <Browse
              showTrending={false}
              onViewAllClick={seacrHide}
              onCategoryClick={seacrHide}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default Seacrhproducts;
